import { z } from "zod";
import en from "./locales/en.json";
import pl from "./locales/pl.json";
import { createI18n } from "vue-i18n";

export type SupportedLocale = "pl" | "en";

export function isSupportedLocale(
  locale: string | undefined | null,
): locale is SupportedLocale {
  return locale === "pl" || locale === "en";
}

function getInitialLocale(): SupportedLocale {
  if (typeof document !== "undefined") {
    const prerenderedLocale = document.getElementById("app")?.dataset.locale;
    if (isSupportedLocale(prerenderedLocale)) return prerenderedLocale;
  }

  if (typeof window !== "undefined" && window.localStorage) {
    const storedLocale = window.localStorage.getItem("locale");
    if (isSupportedLocale(storedLocale)) return storedLocale;
  }

  return "pl";
}

export function createI18nInstance(locale: SupportedLocale = "pl") {
  return createI18n<[typeof en, typeof pl], SupportedLocale>({
    legacy: false,
    locale,
    fallbackLocale: "en",
    messages: { en, pl },
  });
}

// Shared singleton used by the admin app, browser client, and the Zod error map.
// SSR renders use per-request instances from createI18nInstance to avoid leaking
// one request's locale into another under concurrency.
export const i18n = createI18nInstance(getInitialLocale());

z.setErrorMap((issue, ctx) => {
    //@ts-ignore
  const t = i18n.global.t;
  switch (issue.code) {
    case "invalid_type":
      return { message: t("validation.field.required") };
    case "too_small":
      return { message: t("validation.field.tooShort") };
    case "too_big":
      return { message: t("validation.field.tooLong") };
  }
  return { message: ctx.defaultError };
});
